var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex", "flex-direction": "column" } },
    [
      _vm.typeVirtualHbl === _vm.VirtualBillType.NORMAL_VIRTUAL_BILL_TYPE.code
        ? [
            _c("cargo-ag-grid", {
              key: "normal",
              staticStyle: { width: "100%", height: "200px" },
              attrs: {
                "grid-options": _vm.bill.gridOptions,
                "column-defs": _vm.bill.columnDefs,
                "row-data": _vm.billFinalRowData
              }
            })
          ]
        : _vm._e(),
      _vm.typeVirtualHbl === _vm.VirtualBillType.MERGE_VIRTUAL_BILL_TYPE.code
        ? [
            _c("cargo-ag-grid", {
              key: "merge",
              staticStyle: { width: "100%", height: "200px" },
              attrs: {
                "config-module": "2023121501",
                "grid-options": _vm.virtualMergeBill.gridOptions,
                "column-defs": _vm.virtualMergeBill.columnDefs,
                "row-data": _vm.virtualMergeBillFinalRowData
              }
            })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }